import { withLocalState } from 'pyradux';

import ChannelDetailsContainer from './ChannelDetails.container';
import reducer from './ChannelDetails.reducer';

const withLocalStateOptions = {
  reducer,
  stateKey: 'channelDetails',
  sagas: [],
};

export default withLocalState(withLocalStateOptions, ChannelDetailsContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Channels/ChannelDetails/index.js